import api from "../../api";
import {PrivateResourceId} from "platformed-client/types";
import {param, typedQuery} from "../typing";

export const privateResource = typedQuery(
  ["privateResource", param<PrivateResourceId>("privateId")],
  async privateId => await api.privateResources.get(privateId),
);
